import { render } from "./패스워드찾기.vue?vue&type=template&id=7ddd84fe"
import script from "./패스워드찾기.vue?vue&type=script&lang=js"
export * from "./패스워드찾기.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__